import {ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output} from '@angular/core';

require('./bringoz-switch.scss');
@Component({
  standalone: false,
  selector: 'bringoz-switch',
  templateUrl: './bringoz-switch.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozSwitchComponent {

  @Input() classSize: 'sm' | 'md' | 'lg' = 'md';
  @Input() label?: string;
  @Input() checked: boolean;
  @Input() name: string;
  @Input() supportNullState?: boolean = false;
  @Input() isDisabled: boolean = false;
  @Output() onChange = new EventEmitter<any>();

  constructor(@Inject('$timeout') private $timeout) {
  }

  toggle() {
    if (this.isDisabled) {
      return;
    }
    this.onChange.emit(!this.checked);
    this.$timeout(0).then(() => {
    });
  }
}
